import React from "react";
import CompareCareerTable from "../compare/CompareCareerTable";
import { getNumericLeaderIndex } from "../../utils/compareCareerStats";
import {
  formatNflStatValue,
  getNflCompareCareerRowDefs,
  getNflCompareCareerValue,
  getNflCompareSubtitle,
  getNflDisplayName,
  hasNflCareerStats,
} from "../../adapters/nflPlayerAdapter";
import { US_MAJOR_SCOPE } from "../../utils/nflLeagueScope";

const NflHeadToHeadTable = ({
  players = [],
  groupId = "passing",
  selectedStatId,
  showComparison = true,
  leagueScope = US_MAJOR_SCOPE,
}) => {
  const playerSlots = players
    .filter((player) => hasNflCareerStats(player, groupId))
    .map((player) => ({
      id: player.playerId,
      data: player,
    }));

  return (
    <CompareCareerTable
      playerSlots={playerSlots}
      sport="nfl"
      showComparison={showComparison}
      getName={getNflDisplayName}
      getSubtitle={(data) => getNflCompareSubtitle(data, groupId, leagueScope)}
      statRows={getNflCompareCareerRowDefs(groupId)}
      getRawValue={(data, row) => getNflCompareCareerValue(data, row, groupId, leagueScope)}
      formatValue={formatNflStatValue}
      isHighlightedRow={(row) =>
        row.id === selectedStatId || row.key === selectedStatId
      }
      getLeaderIndex={(values, row) =>
        getNumericLeaderIndex(values, {
          lowerIsBetter: Boolean(row.lowerIsBetter),
        })
      }
    />
  );
};

export default NflHeadToHeadTable;
